import React from 'react'
import RealTime from './RealTime'
import { useQueryClient } from '@tanstack/react-query'
import useDebouncedCallback from '@/v2/hooks/useDebouncedCallback'

const RTDailyCalendar = ({ day, monthNumber, year }) => {
  const queryClient = useQueryClient()

  const handleEvent = useDebouncedCallback(() => {
    queryClient.invalidateQueries({
      queryKey: ['appointments'],
      cancelRefetch: true,
    })
    queryClient.invalidateQueries({
      queryKey: ['calendarOccupancy', year, monthNumber, day],
      cancelRefetch: true,
    })
    queryClient.invalidateQueries({
      queryKey: ['NextAppointments'],
      cancelRefetch: true,
    })
    queryClient.invalidateQueries({
      queryKey: ['DailyCalendar'],
      cancelRefetch: true,
    })
    queryClient.invalidateQueries({
      queryKey: ['WeeklyCalendar'],
      cancelRefetch: true,
    })
  }, 500)

  return (
    <RealTime
      channel="Calendar::DayChannel"
      onEvent={handleEvent}
      day={day}
      monthNumber={monthNumber}
      year={year}
    />
  )
}

export default RTDailyCalendar
